"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GS = void 0;
const gs = require("..");
class GS {
    constructor(selector, inElement) {
        const type = typeof (selector);
        this._all = [];
        const tAll = this._all;
        function savePush(e) { const wr = gs.w(e); if (wr)
            tAll.push(wr); }
        switch (type) {
            case 'string':
                if (inElement)
                    inElement.querySelectorAll(selector).forEach(e => savePush(e));
                else
                    document.querySelectorAll(selector).forEach(e => savePush(e));
                break;
            case 'object':
                savePush(selector);
                break;
        }
    }
    static Query(selector) { return new GS(selector); }
    get all() { return [...this._all]; }
    get first() { return this._all[0]; }
    get last() { return this._all[this._all.length - 1]; }
    forEach(callbackfn, thisArg) { this.all.forEach(callbackfn, thisArg); }
    text(value) { this.forEach(w => w.text = value); }
    html(value) { this.forEach(w => w.html = value); }
    disable() { this.forEach(w => w.disable()); }
    ;
    enable() { this.forEach(w => w.enable()); }
    ;
    enableFlip() { this.forEach(w => w.enableFlip()); }
    ;
    enableSet(value) { this.forEach(w => w.enableSet(value)); }
    ;
    hide() { this.forEach(w => w.hide()); }
    show() { this.forEach(w => w.show()); }
    showFlip() { this.forEach(w => w.showFlip()); }
    ;
    showSet(value) { this.forEach(w => w.showSet(value)); }
    ;
    inactive() { this.forEach(w => w.inactive()); }
    ;
    active() { this.forEach(w => w.active()); }
    ;
    activeFlip() { this.forEach(w => w.activeFlip()); }
    ;
    activeSet(value) { this.forEach(w => w.activeSet(value)); }
    addClass(className) { this.forEach(i => i.addClass(className)); }
    ;
    removeClass(className) { this.forEach(i => i.removeClass(className)); }
    ;
    cut() { this.forEach(i => i.cut()); }
    ;
}
exports.GS = GS;
//# sourceMappingURL=GS.js.map